function getStorageKey() {
  const wrapper = document.getElementById('collection_handle');
  return 'availTotal_' + (wrapper ? wrapper.dataset.handle : window.location.pathname);
}

function getCachedAvailableTotal() {
  return parseInt(sessionStorage.getItem(getStorageKey()) || '0', 10);
}

function setCachedAvailableTotal(value) {
  if (value > 0) sessionStorage.setItem(getStorageKey(), value);
}

function applyAvailableTotalFix(total) {
  if (!total || total <= 0) return;
  ['ProductCount', 'ProductCountDesktop', 'PaginationCountDesktop'].forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.innerHTML = el.innerHTML.replace(/of (\d+)(\s*products)/i, `of ${total}$2`);
  });
}

function fetchBaselineAvailableTotal() {
  const grid = document.getElementById('product-grid');
  if (!grid) return;
  const params = new URLSearchParams();
  params.set('filter.v.availability', '1');
  params.set('section_id', grid.dataset.id);
  fetch(`${window.location.pathname}?${params.toString()}`)
    .then((r) => r.text())
    .then((html) => {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const el = parsed.getElementById('collection-available-total');
      const total = el ? parseInt(el.dataset.total, 10) : 0;
      if (total > 0) {
        setCachedAvailableTotal(total);
        applyAvailableTotalFix(total);
      }
    })
    .catch(() => {});
}

document.addEventListener('DOMContentLoaded', function () {
  const el = document.getElementById('collection-available-total');
  const totalOnThisPage = el ? parseInt(el.dataset.total, 10) : 0;
  if (totalOnThisPage > 0) {
    // This page has no non-availability filters active, so its number is trustworthy — cache it.
    setCachedAvailableTotal(totalOnThisPage);
  }

  const cached = getCachedAvailableTotal();
  if (cached > 0) {
    applyAvailableTotalFix(cached);
  } else {
    // First-ever visit landing directly on a filtered URL — nothing cached yet, go fetch it.
    fetchBaselineAvailableTotal();
  }
});

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  /*static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }*/

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML =
      new DOMParser().parseFromString(html, 'text/html')
        .getElementById('ProductGridContainer').innerHTML;

    const isCollectionPage = window.location.pathname.indexOf('/collections/') !== -1;
    const total = getCachedAvailableTotal();
    if (isCollectionPage && total > 0) {
      applyAvailableTotalFix(total);
    }
  }

  /*static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }*/

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    // Update cached total if fresh base count available
    const availableTotalEl = parsedHTML.getElementById('collection-available-total');
    if (availableTotalEl && parseInt(availableTotalEl.dataset.total) > 0) {
      cachedAvailableTotal = parseInt(availableTotalEl.dataset.total);
    }

    // Also check ProductCountDesktop data-available-total (from pagination)
    const paginationCountEl = parsedHTML.getElementById('ProductCountDesktop');
    if (paginationCountEl && parseInt(paginationCountEl.dataset.availableTotal) > 0) {
      cachedAvailableTotal = parseInt(paginationCountEl.dataset.availableTotal);
    }

    const countMobile = parsedHTML.getElementById('ProductCount');
    const countDesktop = parsedHTML.getElementById('ProductCountDesktop');

    const containerMobile = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (containerMobile && countMobile) {
      let countHtml = countMobile.innerHTML;
      if (cachedAvailableTotal > 0) {
        // Replace last "of \d+ products"
        countHtml = countHtml.replace(/of (\d+)(\s*products)/i, `of ${cachedAvailableTotal}$2`);
      }
      containerMobile.innerHTML = countHtml;
      containerMobile.classList.remove('loading');
    }

    if (containerDesktop && countDesktop) {
      let countHtml = countDesktop.innerHTML;
      if (cachedAvailableTotal > 0) {
        // Replace last "of \d+ products"
        countHtml = countHtml.replace(/of (\d+)(\s*products)/i, `of ${cachedAvailableTotal}$2`);
      }
      containerDesktop.innerHTML = countHtml;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  /*createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }*/

  createSearchParams(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams(formData);

    const isCollectionPage = window.location.pathname.indexOf('/collections/') !== -1;
    if (isCollectionPage && !params.has('filter.v.availability')) {
      params.set('filter.v.availability', 1);
    }

    return params.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  /*onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }*/

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });

      // JOIN all form params
      const joined = forms.join('&');

      // ---- FIX: strip ALL availability params then add once ----
      const isCollectionPage = window.location.pathname.indexOf('/collections/') !== -1;
      
      if (isCollectionPage) {
        const merged = new URLSearchParams(joined);
        
        // Delete all instances (handles multiple values for same key)
        merged.delete('filter.v.availability');
        merged.delete('filter.v.availability');
        
        // Append once at the end
        merged.append('filter.v.availability', 1);
        
        this.onSubmitForm(merged.toString(), event);
      } else {
        this.onSubmitForm(joined, event);
      }
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
